import Joi from 'joi';

export const DeactivateLicenseValidator = {
  schema: Joi.object({}).unknown(true)
};
